import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button, Chip } from '@mui/material';

// ICONOS
import AddIcon from '@mui/icons-material/Add';

// SERVICIOS
import { getCoreSysUsers, getIdleConfig } from '../../services/idle_user_config/getDatosIdleConfig';

// COMPONENTES
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import CrearConfig from './modales/CrearConfig';
import EditarConfig from './modales/EditarConfig';

const IdleUserConfig = () => {

    // =========================================
    // ESTADOS PARA MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);

    const [coreSysUser, setCoreSysUser] = useState([]);

    const fetchCoreSysUsers = async () => {

        const data = await getCoreSysUsers();
        setCoreSysUser(data);

    }

    const [data, setData] = useState([]);
    
    const getData = async () => {

        const fetchData = await getIdleConfig();
        setData(fetchData);

    }

    const columns = [

        { 
            field: 'user', 
            headerName: 'Usuarios Configurados',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },

    ];

    // =========================================
    // FUNCION PARA SELECCIONAR FILA
    // =========================================

    const [selected, setSelected] = useState({

        id_user: '',
        json_config: {
            "FLEET1": 0,
            "FLEET2": 0,
            "FLEET3": 0,
            "FLEET4": 0,
            "XFER": 0,
            "USA": 0,
            "BPMX": 0,
        }

    });

    const selectRow = ( params ) => { console.log(params.row)

        setSelected({
            id: params.row.id,
            id_user: params.row.id_user,
            json_config: JSON.parse(params.row.json_config),
        });
        setShowModalEdit(true);

    }

    useEffect(() => {

        fetchCoreSysUsers();
        getData();

    },[]);

    // =========================================

    return (

        <Grid container>

            {/* TITULO */}

            <Grid size={6} marginBottom={2}>
            
                <Typography
                    variant="h5"
                    fontWeight={700}
                >
                    Config Perfiles Idle
                </Typography>

            </Grid>

            {/* BOTONES */}

            <Grid 
                size={6} 
                marginBottom={2}
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end' 
                }}
            >

                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setShowModal(true)}
                    sx={{
                        backgroundColor: 'black'
                    }}
                >
                    Agregar Config
                </Button>

            </Grid>

            {/* TABLA */}

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    data={data}
                    onRowClick={selectRow}
                />

            </Grid>

            {/* MODAL PARA CREAR CONFIG */}

            <CrearConfig
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={getData}
                users={coreSysUser}
            />

            {/* MODAL PARA EDITAR CONFIG */}

            <EditarConfig
                open={showModalEdit}
                onClose={() => setShowModalEdit(false)}
                refresh={getData}
                users={coreSysUser}
                data={selected}
            />

        </Grid>

    )

}

export default IdleUserConfig